import styled from "styled-components";
import {FiltersMobileIconDefaultBox} from "./filters-mobile-icon.default.box";

export const FiltersMobileIconCasino777Box = styled(FiltersMobileIconDefaultBox)`
    background-position: -557px -550px;
`;